const Tenter = () => {

  return (
    <>
      <strong>Pour tenter de gagner un pass 3 jours pour l’édition prochaine et recevoir ta photo</strong>, merci de nous communiquer ton adresse email :  
    </>
  );
};

export default Tenter;